exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".achievements-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center; }\n\n.achievement-badge {\n  width: 252px;\n  height: 230px;\n  border-radius: 19px;\n  margin: 25px;\n  background-color: white;\n  font-size: 14px;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #4a4a4a;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .achievement-badge img {\n    width: 110px; }\n  .achievement-badge h1 {\n    margin: 0;\n    margin-top: 26px;\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 0.4px; }\n  .achievement-badge p {\n    font-weight: 300;\n    font-style: italic;\n    margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/AchievementBadge.scss
// module id = 472
// module chunks = 0